import type { ComponentProps } from 'react'
import Signature from '../../shared/Signature'

type SignatureProps = ComponentProps<typeof Signature>

export default function Step7_Signature(props: SignatureProps) {
  return <Signature {...props} />
}

